import { topicCategories } from "@/mocks/topics";

type TopicsFilterProps = {
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  keyword: string;
  onKeywordChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  resultCount: number;
};

const sortOptions = ["热度优先", "线索最多", "最近更新"];

export default function TopicsFilter({
  activeCategory,
  onCategoryChange,
  keyword,
  onKeywordChange,
  sort,
  onSortChange,
  resultCount,
}: TopicsFilterProps) {
  return (
    <div className="w-full">
      <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:flex-row md:items-center md:justify-between md:p-5">
        <label className="flex w-full items-center gap-2.5 rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 md:max-w-sm">
          <i className="ri-search-line text-base leading-none text-foreground-400"></i>
          <input
            type="search"
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            placeholder="搜索选题关键词，如：骑手、退费、加装电梯"
            className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            aria-label="搜索选题"
          />
        </label>

        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-500">排序</span>
          <div className="flex flex-wrap gap-1.5">
            {sortOptions.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => onSortChange(option)}
                className={`rounded-full px-3.5 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  sort === option
                    ? "bg-foreground-900 text-background-50"
                    : "border border-background-300 text-foreground-600 hover:border-foreground-400"
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-2">
        {topicCategories.map((category) => {
          const active = category === activeCategory;
          return (
            <button
              key={category}
              type="button"
              onClick={() => onCategoryChange(category)}
              className={`rounded-full px-4 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {category}
            </button>
          );
        })}
        <span className="ml-auto text-xs text-foreground-500">
          共 <strong className="text-foreground-900">{resultCount}</strong> 条选题
        </span>
      </div>
    </div>
  );
}